/*
 * NOTE: Don't inherit from error because of
 * https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
 */
export default abstract class DomainException {
  public readonly message: string
  public readonly id: string

  protected constructor (message: string, id: string) {
    this.message = message
    this.id = id
  }

  /*
   * NOTE: When an exception is caught by Next itself, it will try
   * to log it calling its "toString()" method.
   *
   * For JS/TS classes, this method returns the value "[object Object]",
   * which is not very helpful by itself.
   *
   * That is why we are overriding this method, so in the case Next catches
   * an exception of this type, it will log all its innards thanks to JSON.stringify()
   */
  public toString (): string {
    return JSON.stringify(this)
  }
}
